import { render, staticRenderFns } from "./GoodsManagement.vue?vue&type=template&id=6a6ab398&scoped=true&"
import script from "./GoodsManagement.vue?vue&type=script&lang=js&"
export * from "./GoodsManagement.vue?vue&type=script&lang=js&"
import style0 from "./GoodsManagement.vue?vue&type=style&index=0&id=6a6ab398&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6ab398",
  null
  
)

export default component.exports